import { NativeSettings, AndroidSettings } from 'capacitor-native-settings';
import { isAndroidCapacitor } from './platform';

/**
 * Opens the Android system settings for the app
 * This allows users to manually grant permissions
 */
export const openAndroidAppSettings = async (): Promise<void> => {
  if (!isAndroidCapacitor()) {
    console.warn('openAndroidAppSettings called on non-Android platform');
    return;
  }

  try {
    await NativeSettings.openAndroid({
      option: AndroidSettings.ApplicationDetails
    });
  } catch (error) {
    console.error('Failed to open Android settings:', error);
    throw new Error('Unable to open system settings');
  }
};

/**
 * Checks if we can open system settings on the current platform
 */
export const canOpenSystemSettings = (): boolean => {
  // Now we can open settings on Android
  return isAndroidCapacitor();
};